import {
    BottomSheet as UIBottomSheet,
    Box,
    Button as UiButton,
    Divider as UiDivider,
    IconButton as UiIconButton,
    Typography,
    styled,
} from "@l2r-front/l2r-ui"

import { MyAvatar } from "../../../../common/containers/MyAvatar"

const AVATAR_SIZE = 80

export const Container = styled(Box)(() => ({
    display: "flex",
    flexDirection: "column",
    height: "100%",
}))

export const IconButton = styled(UiIconButton)(({ theme }) => ({
    float: "right",
    color: theme.palette["objects/object-black"].main,
}))

export const UserInfos = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.spacing(6),
    position: "relative",
    marginBottom: theme.spacing(6),
}))

export const Avatar = styled(MyAvatar)(() => ({
    width: AVATAR_SIZE,
    height: AVATAR_SIZE,
    fontSize: 40,
}))

export const UserDetails = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.spacing(1),
}))

export const UserEmail = styled(Typography)(({ theme }) => ({
    color: theme.palette["text/disabled"].main,
}))

export const Divider = styled(UiDivider)(({ theme }) => ({
    color: theme.palette["objects/object-lightgrey"].main,
    margin: theme.spacing(0, -6),
    width: `calc(100% + ${theme.spacing(12)})`,
}))

export const SettingsContainer = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(6),
    overflowY: "auto",
}))

export const SettingCategory = styled("div")(() => ({
    display: "flex",
    flexDirection: "column",
}))

export const SettingCategoryTitle = styled(Typography)(({ theme }) => ({
    textTransform: "uppercase",
    color: theme.palette.primary.light,
    marginBottom: theme.spacing(3),
}))

export const Footer = styled("div")(() => ({
    width: "100%",
    marginTop: "auto",
}))

export const LogoutButton = styled(UiButton)(() => ({
    width: "100%",
    boxShadow: "none",
}))

export const BottomSheet = styled(UIBottomSheet)(({ theme }) => ({
    zIndex: theme.zIndex["modal"] + 1,
}))